// Actions for generic SearchableValue components (IPs, URLs, File Hashes, etc.)
import Reflux from 'reflux'

export default Reflux.createActions([
  'show', // (actionType, value)
  'reset',
  'setActionType', //(actionType)
  'backToActions'
])
